export default __webpack_public_path__ + "62197731f6c384b5902195dd4179ebec.svg";